import Search from "@client/controls/Inputs/Search/component";
import { type LabelValue } from "@client/types";
import classnames from "classnames";
import * as React from "react";

export interface GridFilterProps {
  activeTag: string;
  className: string;
  containerClassName?: string;

  onSearch?: (text: string) => void;
  onTagClick: (value: string) => void;

  searchText?: string;

  tags: LabelValue<string>[];
}

const GridFilter = React.memo((props: GridFilterProps) => (
  <div className={props.containerClassName}>
    {!!props.onSearch && <Search autoFocus onChangeDelay={300} value={props.searchText!} onChange={props.onSearch} />}

    <nav className={classnames("grid-filter", props.className)}>
      <ul>
        {props.tags.map((tag) => (
          <li
            key={tag.value}
            className={classnames({ active: tag.value === props.activeTag })}
            onClick={() => props.onTagClick(tag.value)}
          >
            <a href="#" onClick={(e) => e.preventDefault()}>
              {tag.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  </div>
));

export default GridFilter;
